var WDN = WDN || {};

if (typeof WDN.Slides === "undefined") {
  WDN.Slides = (function () {
    var Module;

    Module = function (config) {
      // Store configuration
      this.config = config;

      // Will be populated on init
      this.selectors = {};
      this.nodes = {};

      // State
      this.activeSlide = false;

      // init
      this.init();
    };

    Module.prototype.assignNodes = function () {
      this.selectors = {
        slide: "[data-slide][data-slide-group='" + this.config.group + "']",
        trigger: "[data-slide-to][data-slide-group='" + this.config.group + "']",
      };

      this.nodes = {
        slides: Array.from(document.querySelectorAll(this.selectors.slide)),
        triggers: Array.from(document.querySelectorAll(this.selectors.trigger)),
      };
    };

    Module.prototype.getSlideByID = function (id) {
      if (typeof id === "undefined") return false;

      return this.nodes.slides.filter(function (slide) {
        return slide.getAttribute("data-slide") === id;
      })[0];
    };

    Module.prototype.clearActiveSlide = function () {
      if (this.activeSlide) {
        this.activeSlide.removeAttribute("data-active-slide");
      }
    };

    Module.prototype.setActiveSlide = function (newSlide) {
      if (!newSlide) return;

      // Clear active slide
      this.clearActiveSlide();

      // Set new active slide
      this.activeSlide = newSlide;
      this.activeSlide.setAttribute("data-active-slide", "");
    };

    // Event handlers
    Module.prototype.triggerOnClick = function (e) {
      e.preventDefault();

      var triggerID = e.currentTarget.getAttribute("data-slide-to");

      // if back clicked
      if (triggerID === "back") {
        this.clearActiveSlide();
        return;
      }

      // Find slide and set it active
      var requestedSlide = this.getSlideByID(triggerID);
      this.setActiveSlide(requestedSlide);
    };

    // Event listeners
    Module.prototype.listenForEvents = function () {
      // Listen for trigger click
      this.nodes.triggers.forEach(function (trigger) {
        trigger.addEventListener("click", this.triggerOnClick.bind(this));
      }, this);
    };

    // Init
    Module.prototype.init = function () {
      if (!this.config || !this.config.group) return;

      // Assign nodes
      this.assignNodes();

      // Listen for events
      this.listenForEvents();
    };

    return Module;
  })();
}
